import api from './api';

const API_PREFIX = '/managedInstaller';

const getManagedInstallersAll = ({ limit, page, customerEnvId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getManagedInstallersDeviceAll = ({ limit, page, customerEnvId, query, deviceId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/device/${deviceId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getManagedInstallersDetails = ({ customerEnvId, managedInstallerId, }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${managedInstallerId}`);

const getManagedInstallersAffectedDevices = ({ limit, page, customerEnvId, managedInstallerId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${managedInstallerId}/affectedDevices${query}`,
    { params: {
        ...(limit ? { Limit: limit } : {}),
        ...(page ? { Page: page } : {}),
      },});

const getManagedInstallersUnaffectedDevices = ({ limit, page, customerEnvId, managedInstallerId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${managedInstallerId}/unaffectedDevices${query}`,
    { params: {
        ...(limit ? { Limit: limit } : {}),
        ...(page ? { Page: page } : {}),
      },});

const getManagedInstallersTabCounts = ({ customerEnvId, managedInstallerId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${managedInstallerId}/tabCounts`);

const getExportDevices = ({ customerEnvId, managedInstallerId, query, exportAffected }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${managedInstallerId}/exportDevices${query}`, {
    params: {
      ExportAffected: exportAffected,
    },
  });

const ManagedInstallerService = {
  getManagedInstallersAll,
  getManagedInstallersDeviceAll,
  getManagedInstallersDetails,
  getManagedInstallersAffectedDevices,
  getManagedInstallersUnaffectedDevices,
  getManagedInstallersTabCounts,
  getExportDevices
};

export default ManagedInstallerService;
